import script from "./DisablingNetworksBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisablingNetworksBanner.vue?vue&type=script&setup=true&lang=ts"

import "./DisablingNetworksBanner.vue?vue&type=style&index=0&id=12c6df02&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c6df02"]])

export default __exports__